/**
 * @prettier
 */

import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import { isUploadcareEnabled } from 'components/common/UploadcareWidget/constants';
import FeatureFlags from '../../../../../util/featureFlags';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import SamplePreview from '../SamplePreview/SamplePreview';
import Layout from '../Layout';
import PhotoUpload from '../PhotoUpload/PhotoUpload';
import { STEPS } from '../constants/steps';
import styles from './styles.module.less';

const FileUpload = ({
  form,
  goToStep,
  updateForm,
  step,
  breadcrumbSteps,
  template,
  colors,
  sampleNotCustomizable,
  skuData,
  cardSuiteDetails,
  isMagnet,
  isMulti,
  setMultiPreviewState,
  multiPreviewState,
  cardSuiteUUIDList,
  cardSuiteDetailsSet,
  defaultTemplateSet,
}) => {
  const elements = (template && template.pages[0].elements) || [];

  const customizableImage = elements.find(
    element => element.content_type === 'IMAGE' && element.customizable
  );

  let nextStep;

  if (!isUploadcareEnabled) {
    nextStep = STEPS.PHOTO_CROP;
  } else if (isMulti) {
    nextStep = STEPS.MULTI_UPLOAD_HELP;
  } else if (FeatureFlags.get('invitesSingleSampleCustomizeStep') && !sampleNotCustomizable) {
    nextStep = STEPS.CUSTOMIZATION;
  } else {
    nextStep = STEPS.WEDDING_DETAILS_FORM;
  }

  return (
    <Layout.Box>
      <Layout.Row>
        <Layout.PreviewBox>
          <SamplePreview
            hideColorPicker={sampleNotCustomizable}
            colors={colors}
            template={template}
            form={form}
            sampleNotCustomizable={sampleNotCustomizable}
            updateForm={updateForm}
            skuData={skuData}
            cardSuiteDetails={cardSuiteDetails}
            isMagnet={isMagnet}
            isMulti={isMulti}
            setMultiPreviewState={setMultiPreviewState}
            multiPreviewState={multiPreviewState}
            cardSuiteUUIDList={cardSuiteUUIDList}
            cardSuiteDetailsSet={cardSuiteDetailsSet}
          />
        </Layout.PreviewBox>
        <Layout.Col>
          <BreadCrumbs.Text step={step} breadcrumbSteps={breadcrumbSteps} />
          <Layout.Header>Add a Photo</Layout.Header>
          <Layout.Text>
            Go with your favorite shot of you two. Guests love seeing this personal touch!
          </Layout.Text>
          <PhotoUpload.Dropzone
            imageElement={customizableImage}
            form={form}
            updateForm={updateForm}
            template={template}
            cardSuiteUUIDList={cardSuiteUUIDList}
            defaultTemplateSet={defaultTemplateSet}
            onSuccess={() => goToStep(isUploadcareEnabled ? nextStep : STEPS.PHOTO_CROP)}
          />
          <div className={styles.skipLinkBox}>
            <Link
              inline
              role="button"
              onClick={() => {
                if (isMulti) {
                  goToStep(STEPS.MULTI_UPLOAD_HELP);
                } else if (
                  FeatureFlags.get('invitesSingleSampleCustomizeStep') &&
                  !sampleNotCustomizable
                ) {
                  goToStep(STEPS.CUSTOMIZATION);
                } else {
                  goToStep(STEPS.WEDDING_DETAILS_FORM);
                }
              }}
            >
              Skip this step
            </Link>
          </div>
        </Layout.Col>
      </Layout.Row>
      <BreadCrumbs.Dots step={step} breadcrumbSteps={breadcrumbSteps} />
    </Layout.Box>
  );
};

export default FileUpload;
